// Voucher value helpers shared between the voucher detail page, contract
// detail page, and the reconciliation table.
//
// The single rule encoded here: `voucher.financing_sources[*].tax` is the
// authoritative tax figure once it has been populated (story 150 phase 4).
// Vouchers that pre-date the back-fill (no FS array, or an FS array whose
// entries don't carry a tax field) fall back to `voucher.tax_withheld`.

import type { Voucher } from '../@types';

/**
 * The tax withheld on a voucher, in the voucher's own currency.
 *
 * Prefers the sum of `voucher.financingSources[*].tax` when the array is
 * present and non-empty. Falls back to `voucher.taxWithheld` for legacy
 * vouchers (and for the brief window between `prepare payment` and the
 * back-fill running in environments older than story 149).
 */
export function getVoucherTaxWithheld(
	voucher: Pick<Voucher, 'financingSources' | 'taxWithheld'>
): number {
	const fs = voucher.financingSources;
	if (fs && fs.length > 0) {
		return fs.reduce((sum, s) => sum + (Number(s.tax) || 0), 0);
	}
	return Number(voucher.taxWithheld) || 0;
}
